import useCustomHook from '@/hooks/useCustomHook';

export default function useMemoryGameActivity({
  taskProgressAPI,
  onFinishedActivity,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {},
    actions: {
      onCorrectAnswer: ({ matchedConcepts, cards }) => {
        taskProgressAPI.PROGRESS({
          progress: Math.ceil(
            (matchedConcepts.length * 100) / (cards.length / 2)
          ),
        });
      },
      onFinishedActivity: () => {
        taskProgressAPI?.PROGRESS({ progress: 100 });
        onFinishedActivity();
      },
    },
  });

  return { state, actions };
}
